import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, ToggleButton, Tooltip, useTheme } from '@mui/material';
import { DeployIcon, ReplyAllIcon, ReplyIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { selectHasContactsForSuggestion } from 'store/loanApplications/selectors';

import { getStyles } from '../../../Activities.styles';
import useNewEmailModal from '../../../hooks/useNewEmailModal';

const EmailActions = ({ activity }) => {
  const theme = useTheme();
  const classes = getStyles(theme);

  const hasContactsForSuggestion = useSelector(selectHasContactsForSuggestion);

  const { onCreateReply, onCreateReplyAll, onCreateForward } = useNewEmailModal(activity);

  const actionsConfig = useMemo(
    () => [
      {
        className: classes.replyBtn,
        value: 'reply',
        onChange: onCreateReply,
        icon: ReplyIcon,
        label: 'Reply',
        isEnabled: hasContactsForSuggestion,
      },
      {
        className: classes.replyAllBtn,
        value: 'replyAll',
        onChange: onCreateReplyAll,
        icon: ReplyAllIcon,
        label: 'Reply All',
        isEnabled: hasContactsForSuggestion,
      },
      {
        className: classes.forwardBtn,
        value: 'forward',
        onChange: onCreateForward,
        icon: DeployIcon,
        label: 'Forward',
        isEnabled: hasContactsForSuggestion,
      },
    ],
    [
      classes.forwardBtn,
      classes.replyBtn,
      classes.replyAllBtn,
      onCreateForward,
      onCreateReply,
      onCreateReplyAll,
      hasContactsForSuggestion,
    ],
  );

  return (
    <Box className="border-b" sx={classes.emailActions}>
      {actionsConfig.map(({ className, value, onChange, icon: IconComponent, label, isEnabled }) =>
        isEnabled ? (
          <Tooltip key={value} title={label}>
            <ToggleButton
              className="text-current text-12 h-36 py-6"
              sx={className}
              value={value}
              onChange={onChange}
            >
              <IconComponent className="mr-4" size={IconSize[16]} />
              <span className="hidden lg:flex">{label}</span>
            </ToggleButton>
          </Tooltip>
        ) : (
          <Box key={value} sx={className} />
        ),
      )}
    </Box>
  );
};

EmailActions.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.string,
    from: PropTypes.string,
    subject: PropTypes.string,
    body: PropTypes.string,
    threadId: PropTypes.string,
    cc: PropTypes.array,
    bcc: PropTypes.array,
  }).isRequired,
};

export default EmailActions;
